export * from './card-proposals-report.page'
